(function () {
  var messages = document.querySelectorAll('.announcement-bar__message');
  if (messages.length <= 1) return;

  var idx = 0;
  var len = messages.length;
  var timer;

  function slide() {
    var prev = messages[idx];
    idx = (idx + 1) % len;
    var next = messages[idx];

    prev.classList.remove('is-visible', 'first');
    prev.setAttribute('aria-hidden', 'true');

    prev.addEventListener('transitionend', function show() {
      prev.removeEventListener('transitionend', show);
      next.classList.add('is-visible');
      next.setAttribute('aria-hidden', 'false');
    }, { once: true });

    timer = setTimeout(slide, 6000);
  }

  // Swap .first → .is-visible on first message
  messages[0].classList.remove('first');
  messages[0].classList.add('is-visible');
  timer = setTimeout(slide, 6000);

  var pauseBtn = document.getElementById('pause');
  var playBtn = document.getElementById('play');

  if (pauseBtn) pauseBtn.addEventListener('click', function () {
    clearTimeout(timer);
    pauseBtn.style.display = 'none';
    if (playBtn) playBtn.style.display = '';
  });

  if (playBtn) playBtn.addEventListener('click', function () {
    timer = setTimeout(slide, 6000);
    playBtn.style.display = 'none';
    if (pauseBtn) pauseBtn.style.display = '';
  });
})();
